
import React from 'react';
import { connect } from 'react-redux';
import MetatagsView from './meta-tags-view';
import {
  setMetaTitle,
  setMetaDescription,
} from '../../../../state/actions/meta-tags';

const isCustomTitleTag = (pageTitle, currentTag) => {
  const autoTage = `${pageTitle} | Zicasso`;
  return autoTage !== currentTag;
}

const MetatagsRedux = (props) => (
  <MetatagsView {...props}/>
);

const mapStateToProps = (state, ownProps) => {
  const { entityId:id } = ownProps;
  const editorEntities = state.itineraries.itinerary;
  const { editor } = editorEntities;
  const currentEntity = editor[id] || {};
  const { metatags, title } = currentEntity;
  return {
    title,
    metatags,
    isCustomTitle : isCustomTitleTag(title, metatags.title),
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { entityId:id } = ownProps;
  return {
    onMetaTitleChange: (text) => dispatch(setMetaTitle(text, id)),
    onMetaDescriptionChange: (text) => dispatch(setMetaDescription(text, id)),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(MetatagsRedux);
